import { Action, getActions } from 'apprise-core/action'
import { utils } from 'apprise-core/utils'


// the granting of an action to an identifiable subject, typically a user.
export type Permission = {

    subject: string
    action: Action

}

export type Permissioned = {

    permissions: Action[]
}

// the data-transfer objects exchanged with the permission API to search and change permissions.

export type PermissionFilter = Partial<{

    subjects: string[]
    actions: Action[]
    types: string[]
    resources: string[]
}>

export type Changes = {

    granted?: Permission[]
    revoked?:Permission[]
}



export const getPermissions = () => {

    const actions = getActions()


    const self = {


        idOf: (p: Permission) => `${p.subject}:${actions.idOf(p.action)}`

        ,

        idmapOf: (ps: Permission[]): Record<string, boolean> => utils().index(ps).mappingBy(self.idOf, () => true)


        ,

        reconcile: (permissions: Permission[]): Permission[] => {

            // sort upfront from most generic to most specific, so that reconciliation can be treated in 'streaming' fashion
            const sorted = [...permissions].sort((p1, p2) => actions.comparator(p1.action, p2.action))

            //  simply add one by one if not already implied by previous ones
            const outcome = sorted.reduce((acc, p) => actions.impliedByAny(p.action, acc.filter(pp => p.subject === pp.subject).map(p => p.action)) ? acc : [p, ...acc], [] as Permission[])

            //console.log("to reconcile:",permissions,"reconciled:", outcome);

            return outcome;

        }

    }

    return self;



}